import React from "react";
import { CWBAPI } from "cwb-react";
import qs from "query-string";
import { withI18n } from "react-i18next";
import ConfirmationPage from "./components/ConfirmationPage";
import CWBLabsForgotPwd from "./screens/CWBLabsForgotPwd";
import CWBForgotPwd from "./screens/ForgotPwd";
import { client } from "shared/apiClient";
import { validateEmail } from "shared/helpers";

class ForgotPwd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        email: "",
        firstName: ""
      },
      isLoading: false,
      serverError: {
        message: ""
      },
      clientError: {
        email: "",
        firstName: "",
        accountType: ""
      },
      selectedAccount: {
        label: "Select one"
      },
      accounts: [
        { id: 1, value: "actor", userType: 8, label: "Actor" },
        { id: 2, value: "agent", userType: 3, label: "Agent" },
        { id: 3, value: "casting", userType: 2, label: "Casting Director" },
        { id: 4, value: "performer", userType: 8, label: "Performer" },
        { id: 5, value: "producer", userType: 2, label: "Producer" }
      ],
      redirectToConfirmation: false
    };
  }

  async componentWillMount() {
    const accType = qs.parse(this.props.location.search).accType;

    if (accType) {
      const accountsSearch = this.state.accounts
        .filter(thisAccountType => thisAccountType.id !== 4)
        .map(thisAccountType => thisAccountType.value === 'producer'
          ? { ...thisAccountType, userType: 4 }
          : thisAccountType
        );

      const selectedAccountId = accountsSearch.find(thisAccountType =>
        thisAccountType.userType === parseInt(accType)
      ).id;
      const selectedAccount = this.state.accounts.find(thisAccountType =>
        thisAccountType.id === selectedAccountId
      );

      this.setState({ selectedAccount });
    }
  }

  async componentDidMount() {
    let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
    let localApi = await import(`shared/api`);
    client.api = new CWBAPI(
      { ...api.default, ...localApi.default },
      CWB_API_ENV,
      CWB_USE_MOCK_ENV
    );
    this.setState({
      selectedAccount: {
        ...this.state.selectedAccount,
        label: this.props.t(this.state.selectedAccount.label),
      },
      accounts: this.state.accounts.map(item => ({
        ...item,
        label: this.props.t(item.label)
      }))
    });
  }

  onChangeField = e => {
    const { name, value } = e.target;
    this.setState({ clientError: null });
    this.setState(oldState => {
      return {
        user: {
          ...oldState.user,
          [name]: value
        }
      };
    });
  };

  setServerError = serverError => {
    this.setState({
      serverError
    });
  };

  setClientError = clientError => {
    this.setState({
      clientError
    });
  };

  onKeyPress = event => {
    if (event.key === "Enter") {
      this.onSubmit();
      event.preventDefault();
    }
  };

  setIsLoading = isLoading => {
    this.setState({
      isLoading
    });
  };

  onSubmit = async () => {
    if (this.state.isLoading) return;
    this.setIsLoading(true);
    this.setServerError(null);
    this.setClientError(null);

    if (!this.checkValidation()) {
      this.setIsLoading(false);
      return;
    }

    let resp;
    try {
      const { user, selectedAccount } = this.state;
      resp = await client.api.auth.forgotPasswordByAccount(
        user.email,
        user.firstName,
        selectedAccount.userType
      );
      this.handleForgotPwdResponse(resp);
    } catch (error) {
      console.log(error);

      const errorMsg = this.props.t(
        "We could not process your request. Please review your information and try again or contact our support team."
      );
      if (error.response && error.response.data) {
        if (error.response.data && typeof (error.response.data) != 'string' && (!error.response.data.message)) {
          error.response.data.message = errorMsg;
          this.setServerError(error.response.data);
        } else {
          this.setServerError({ success: false, message: errorMsg });
        }

      } else {
        this.setServerError({ success: false, message: errorMsg });
      }
    } finally {
      this.setIsLoading(false);
    }
  };

  handleForgotPwdResponse = resp => {
    if (resp && resp.data && resp.data.success) {
      this.setState({ redirectToConfirmation: true });
    } else {
      this.setServerError({
        message: this.props.t(
          "We could not process your request. Please review your information and try again or contact our support team."
        )
      });
    }
  };

  checkValidation = () => {
    const { user, selectedAccount } = this.state;
    const { t } = this.props;

    if (
      !selectedAccount ||
      !selectedAccount.value ||
      !selectedAccount.userType
    ) {
      this.setState({
        clientError: {
          ...this.state.clientError,
          accountType: t("You must select an account type.")
        }
      });
      return false;
    }
    if (selectedAccount.userType == 8 && !user.firstName) {
      this.setState({
        clientError: { ...this.state.clientError, firstName: t("First name is required.") }
      });
      return false;
    }
    if (!validateEmail(user.email)) {
      this.setState({
        clientError: { ...this.state.clientError, email: t("Invalid email") }
      });
      return false;
    }
    return true;
  };

  render() {
    const {
      user,
      isLoading,
      serverError,
      clientError,
      accounts,
      selectedAccount,
      redirectToConfirmation
    } = this.state;

    if (redirectToConfirmation) return <ConfirmationPage email={user.email} />;

    const isCWBLabs = qs.parse(this.props.location.search).cwblabs;

    return isCWBLabs ? (
      <CWBLabsForgotPwd
        accounts={accounts}
        clientError={clientError}
        isLoading={isLoading}
        selectedAccount={selectedAccount}
        serverError={serverError}
        user={user}
        onChangeField={this.onChangeField}
        onChangeSelectedAccount={e => {
          this.setClientError(null);
          this.setState({ selectedAccount: e.target.value });
        }}
        onKeyPress={this.onKeyPress}
        onSubmit={this.onSubmit}
      />
    ) : (
      <CWBForgotPwd
        accounts={accounts}
        clientError={clientError}
        isLoading={isLoading}
        selectedAccount={selectedAccount}
        serverError={serverError}
        user={user}
        onChangeField={this.onChangeField}
        onChangeSelectedAccount={option => {
          this.setClientError(null);
          this.setState({ selectedAccount: option });
        }}
        onKeyPress={this.onKeyPress}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withI18n()(ForgotPwd);
